<!-- 我的账户-投资分享 -->
<template>
  <div class="common-box border-t0">
    <p class="instruction-li-title margin-t10">投资分享</p>
    <el-form class="form-single-inline margin-t20" :inline="true" :model="shareAdd" ref="shareAdd" :rules="shareAddRules">
      <el-form-item prop="con">
        <el-input type="textarea" placeholder="请输入分享内容" v-model="shareAdd.con" style="width:1010px" :autosize="{minRows:2}"></el-input>
        <el-button type="search" style="margin-left:20px;vertical-align:text-bottom;" @click="addShare()">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="shareData" class="table-single margin-t5">
      <el-table-column label="日期" prop="addedDate" width="100"></el-table-column>
      <el-table-column label="投资分享">
        <template slot-scope="scope">
          <pre v-if="scope.row.isEdit==false" style="text-align:left;">{{scope.row.message}}</pre>
          <el-input v-else type="textarea" v-model="scope.row.messageEdit" autosize></el-input>
        </template>
      </el-table-column>
      <el-table-column label="图片" prop="imgUrl" width="210">
        <template slot-scope="scope">
          <!-- 图片展示 imgUrl -->
          <template v-if="scope.row.isEdit==false">
            <div v-if="scope.row.imgUrl !='' && scope.row.imgUrl != '--'">
              <el-image v-for="(item,i) in scope.row.imgUrl" :key="i+'img'" :src="item" style="float:left;width:80px;height:80px;margin-right:10px;;margin-bottom:10px;" :preview-src-list="[item]"></el-image>
            </div>
            <span v-else>--</span>
          </template>
          <!-- 图片编辑 imgUrlEdit -->
          <template v-else style="border:1px solid #ccc;">
            <el-upload class="upload-one" action list-type="picture-card" :file-list="scope.row.imgUrlEdit" :on-change="(file, fileList) => {onChangeFile(file, fileList, scope.row.imgUrlEdit)}" :auto-upload="false" accept=".jpg,.jpeg,.png">
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{file}">
                <img class="el-upload-list__item-thumbnail imageWay" :src="file.url" alt="">
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-delete" @click="handleRemove(file,scope.row.imgUrlEdit)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="视频(1个)" prop="videoUrl" width="100">
        <template slot-scope="scope">
          <!-- 视频展示 imgUrl -->
          <template v-if="scope.row.isEdit==false">
            <a v-if="scope.row.videoUrl!='--' && scope.row.videoUrl!=''" :href="scope.row.videoUrl" target="blank">
              <img src="../../assets/images/radio.png" style="width:50px;">
            </a>
            <span v-else>--</span>
          </template>
          <!-- 视频编辑  -->
          <template v-else style="border:1px solid #ccc;">
            <el-upload action="#" class="upload-one" list-type="picture-card" :auto-upload="false" :on-change="(file, fileList) => {uploadHeadPortrait(file, fileList, scope.row)}" :show-file-list="false" accept=".mp4">
              <span>{{scope.row.videoUrlEditName}}</span>
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <template v-if="scope.row.isEdit==false">
            <i class="el-icon-edit-outline table-single-icon" @click="editShare(scope.$index,scope.row)"></i>
            <i class="el-icon-delete table-single-icon" @click="delShare(scope.row.id)"></i>
          </template>
          <template v-else>
            <i class="el-icon-check table-single-icon" @click="editShareOpt('sure',scope.$index)"></i>
            <i class="el-icon-close table-single-icon" @click="editShareOpt('cancel',scope.$index)"></i>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination-single" @current-change="handleCurrentChange" :current-page.sync="pageNum" :page-size="pageSize" layout="prev, pager, next" :total="total" hide-on-single-page>
    </el-pagination>
    <p class="instruction-li-title margin-t50">热推产品</p>
    <el-form class="form-single-inline margin-t20" :inline="true" :model="searchProduct" ref="searchProduct" :rules="searchProductRules">
      <el-form-item prop="fundcode">
        <el-select v-model="searchProduct.fundcode" style="width:450px" placeholder="请输入基金名称/代码" filterable remote :remote-method="remoteSearch" :loading="loading">
          <el-option v-for="item in fundList" :key="item.fundCode" :label="item.fundName" :value="item.fundCode">
            <span style="float: left">{{ item.fundCode }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.fundName }}</span>
          </el-option>
        </el-select>
        <el-button type="search" class="margin-l20" @click="productAdd()">点击新增</el-button>
        <span class="warnColor margin-l15">（提示：热推产品数量最多为<strong>3</strong>）</span>
      </el-form-item>
    </el-form>
    <el-table :data="productData" class="table-single margin-t5">
      <el-table-column label="基金名称" prop="fundName" width="150"></el-table-column>
      <el-table-column label="今年以来收益" prop="thisYearYield" width="110">
        <template slot-scope="scope">
          <span :class="[{'rColor':scope.row.thisYearYield>0},{'gColor':scope.row.thisYearYield<0}]">{{(scope.row.thisYearYield*100).toFixed(2)}}%</span>
        </template>
      </el-table-column>
      <el-table-column label="近一年收益" prop="oneYearYield" width="110">
        <template slot-scope="scope">
          <span :class="[{'rColor':scope.row.oneYearYield>0},{'gColor':scope.row.oneYearYield<0}]">{{(scope.row.oneYearYield*100).toFixed(2)}}%</span>
        </template>
      </el-table-column>
      <el-table-column label="产品特点" width="160">
        <template slot-scope="scope">
          <pre v-if="productDataEdit[scope.$index].isEdit==false" class="text-l" style="text-align:left;">{{scope.row.characteristic}}</pre>
          <el-input v-else v-model="productDataEdit[scope.$index].characteristic" type="textarea" autosize></el-input>
        </template>
      </el-table-column>
      <el-table-column label="推荐理由">
        <template slot-scope="scope">
          <pre v-if="productDataEdit[scope.$index].isEdit==false" class="text-l" style="text-align:left;">{{scope.row.reason}}</pre>
          <el-input v-else v-model="productDataEdit[scope.$index].reason" type="textarea" autosize></el-input>
        </template>
      </el-table-column>
      <el-table-column label="推荐人数" prop="adviserCount" width="80"></el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <template v-if="productDataEdit[scope.$index].isEdit==false">
            <i class="el-icon-edit-outline table-single-icon" @click="productDataEdit[scope.$index].isEdit=true"></i>
            <i class="el-icon-delete table-single-icon" @click="delProduct(scope.row.id)"></i>
          </template>
          <template v-else>
            <i class="el-icon-check table-single-icon" @click="editProductOpt('sure',scope.$index)"></i>
            <i class="el-icon-close table-single-icon" @click="editProductOpt('cancel',scope.$index)"></i>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <!-- 图片 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "investmentSharing",
  data () {
    return {
      // 投资分享
      shareAdd: {
        con: ''
      },
      shareAddRules: {
        con: [
          { required: true, message: '请输入分享内容', trigger: 'change' }
        ]
      },
      shareData: [],
      pageNum: 1,
      pageSize: 3,
      total: 0,
      // 热推产品
      productData: [],
      productDataEdit: [],
      searchProduct: {
        fundcode: '',
      },
      loading: false,
      fundList: [],
      searchProductRules: {
        fundcode: [
          { required: true, message: '请选择基金', trigger: 'change' }
        ]
      },
      // 上传图片
      dialogImageUrl: '',
      dialogVisible: false
    }
  },
  mounted () {
    this.getShareFun();
    this.getProductFun();
  },
  methods: {
    // 投资分享
    getShareFun () {
      const vm = this;
      vm.$http.post(vm.$apiPath.getInvestmentAdviserShareList, {
        AdviserCode: vm.$commonJs.getCookie('code'),
        Page: vm.pageNum,
        PageNum: vm.pageSize
      }).then(res => {
        // console.log(res);
        if (res.data.code == 200) {
          let sdata = res.data.data.dataList;
          vm.shareData = [];
          if (sdata && sdata.length > 0) {
            sdata.forEach((v, i) => {
              vm.shareData.push({
                id: v.id,
                addedDate: v.addedDate,
                message: v.message,
                imgUrl: v.imgUrl == "--" ? [] : v.imgUrl.split(','),//图片
                videoUrl: v.videoUrl,//视频
                isEdit: false,
                messageEdit: v.message,
                imgUrlEdit: [],//存放图片数组
                videoUrlEdit: v.videoUrl,
                videoUrlEditName: '',//视频名字
              })
            })
          }
          vm.total = res.data.data.recordCount;
        }
      })
    },
    // 分页
    handleCurrentChange (val) {
      this.pageNum = val;
      this.getShareFun();
    },
    // 投资分享 新增
    addShare () {
      const vm = this;
      vm.$refs['shareAdd'].validate((valid) => {
        if (valid) {
          vm.$http.post(vm.$apiPath.addedInvestmentAdviserShare, {
            AdviserCode: vm.$commonJs.getCookie('code'),
            Message: vm.shareAdd.con
          }).then(res => {
            if (res.data.code == 200) {
              vm.$message.success('新增成功');
              vm.pageNum = 1;
              vm.getShareFun();
              vm.$refs['shareAdd'].resetFields();
            }
          })
        } else {
          setTimeout(function () {
            if (vm.shareAdd.con == '') {
              vm.$refs['shareAdd'].resetFields();
            }
          }, 3000)
        }
      })
    },
    // 投资分享 删除
    delShare (i) {
      const vm = this;
      vm.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        vm.$http.post(vm.$apiPath.deleteInvestmentAdviserShare, { id: i }).then(res => {
          if (res.data.code == 200) {
            vm.$message.success('删除成功');
            let currentPageSum = Math.ceil((vm.total - 1) / vm.pageSize);
            let currentPage = vm.pageNum > currentPageSum ? currentPageSum : vm.pageNum;
            vm.pageNum = currentPage < 1 ? 1 : currentPage;
            vm.getShareFun();
          }
        })
      }).catch(() => {
        vm.$message.info('已取消删除')
      })
    },
    // 投资分享 编辑
    editShare (index, row) {
      this.shareData[index].isEdit = true;
      row.imgUrlEdit = [];
      if (row.imgUrl != '') {
        let urlStr = row.imgUrl;
        urlStr.forEach(async (item, i) => {
          let obj = new Object();
          obj.url = item
          obj.index = i + 1
          row.imgUrlEdit.push(obj);
          // console.log(obj);
        });
      }
    },
    getBlobByUrl (url, cb) {
      let xhr = new XMLHttpRequest();
      xhr.open("get", url, true);
      xhr.responseType = "blob";
      xhr.onload = function () {
        if (xhr.status == 200) {
          if (cb) cb(xhr.response)
        }
      };
      xhr.send();
    },
    editShareOpt (opt, index) {
      const vm = this;
      if (opt == 'sure') {
        // 图片
        let imgUrlStr = ''
        //原图片需要用XMLHttpRequest解析URL获取，异步函数，不加锁会直接上传，而不等待HTTP响应结束
        //数量，确保所有图片都已遍历结束
        let num = 0;
        vm.shareData[index].imgUrlEdit.forEach(item => {
          //旧图片获取到的是URL，需要通过XMLHttpRequest解析URL获取
          if (item.url.indexOf("https://www.myfund.com/") != -1) {
            const reader = new FileReader()
            //通过URL获取图片的Base64
            this.getBlobByUrl(item.url, function (blob) { reader.readAsDataURL(blob) });
            //URL获取完成Base64的回调函数
            reader.onload = function () {
              imgUrlStr += reader.result + '|'
              num++;
              //回调函数有延时，所以需要在此继续判断所有图片是否都已转换完成
              if (num === vm.shareData[index].imgUrlEdit.length) {
                vm.upImage(index, imgUrlStr);
              }
            }
          } else {
            imgUrlStr += item.url + '|';
            num++;
          }
        })
        //判断所有图片是否都已转换完成
        if (num === vm.shareData[index].imgUrlEdit.length) {
          vm.upImage(index, imgUrlStr);
        }
      } else {
        vm.shareData[index].messageEdit = vm.shareData[index].message;
        vm.shareData[index].isEdit = false;
      }
    },
    upImage (index, imgUrlStr) {
      const vm = this;
      vm.$http.post(vm.$apiPath.updateInvestmentAdviserShare, {
        AdviserCode: vm.$commonJs.getCookie('code'),
        id: vm.shareData[index].id,
        message: vm.shareData[index].messageEdit,
        ImgUrl: imgUrlStr.slice(0, -1),
        VideoUrl: vm.shareData[index].videoUrlEdit,
      }).then(res => {
        if (res.data.code == 200) {
          vm.shareData[index].message = vm.shareData[index].messageEdit;
          vm.shareData[index].imgUrl = res.data.data.imgUrl.split(',');
          vm.shareData[index].videoUrl = res.data.data.videoUrl;
          vm.shareData[index].isEdit = false;
        }
      })
    },
    // 删除图片
    handleRemove (file, urlArr) {
      const tPic = file.index;
      const i = urlArr.findIndex(item => item.index == tPic)
      urlArr.splice(i, 1)
    },
    // 图片
    onChangeFile (file, fileList, urlArr) {
      const vm = this;
      let fileRaw = file.raw;
      vm.getBase64(fileRaw).then(result => {
        // console.log("base64格式：", result);
        urlArr.push({ url: result })// 添加到数组
      });
      urlArr.forEach((item, i) => {
        item.index = i
      })
    },
    // 视频
    uploadHeadPortrait (file, fileList, row) {
      const vm = this;
      row.videoUrlEditName = file.raw.name;
      vm.getBase64(file.raw).then(result => {
        row.videoUrlEdit = result
      });
    },
    // 文件转base64格式
    getBase64 (file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    // 热推产品
    getProductFun () {
      const vm = this;
      vm.$http.post(vm.$apiPath.getInvestmentAdviserHotRecommend, {
        AdviserCode: vm.$commonJs.getCookie('code')
      }).then(res => {
        if (res.data.code == 200) {
          let sdata = res.data.data.productList;
          vm.productData = sdata;
          vm.productDataEdit = [];
          if (sdata && sdata.length > 0) {
            sdata.forEach((val, ind) => {
              vm.productDataEdit.push({
                isEdit: false,
                characteristic: val.characteristic,
                reason: val.reason
              })
            })
          }
        }
      })
    },
    // 热推产品 搜索+新增
    remoteSearch (query) {
      const vm = this;
      if (query == '') {
        vm.fundList = [];
      } else {
        vm.loading = true;
        vm.$http.post(vm.$apiPath.getPrivateFundList, {
          KeyWords: query
        }).then(res => {
          if (res.data.code == 200) {
            vm.fundList = res.data.data.productList;
            vm.loading = false;
          }
        })
      }
    },
    productAdd () {
      const vm = this;
      if (vm.productData.length < 3) {
        vm.$refs['searchProduct'].validate(valid => {
          if (valid) {
            vm.$http.post(vm.$apiPath.addInvestmentAdviserHotRecommend, {
              AdviserCode: vm.$commonJs.getCookie('code'),
              FundCode: vm.searchProduct.fundcode
            }).then(res => {
              if (res.data.code == 200) {
                vm.getProductFun();
                vm.$refs['searchProduct'].resetFields();
              }
            })
          } else {
            setTimeout(function () {
              if (vm.searchProduct.fundcode == '') {
                vm.$refs['searchProduct'].resetFields();
              }
            }, 3000)
          }
        })
      } else {
        vm.$message.warning('提示：热推产品数量最多为3只');
      }
    },
    // 热推产品 删除
    delProduct (id) {
      const vm = this;
      vm.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        vm.$http.post(vm.$apiPath.deleteInvestmentAdviserHotRecommend, {
          id: id
        }).then(res => {
          if (res.data.code == 200) {
            vm.$message.success('删除成功');
            vm.getProductFun();
          }
        })
      }).catch(() => {
        vm.$message.info('已取消删除')
      })
    },
    // 热推产品 编辑
    editProductOpt (opt, index) {
      const vm = this;
      if (opt == 'sure') {
        vm.$http.post(vm.$apiPath.updateInvestmentAdviserHotRecommend, {
          id: vm.productData[index].id,
          Character: vm.productDataEdit[index].characteristic,
          Reason: vm.productDataEdit[index].reason
        }).then(res => {
          if (res.data.code == 200) {
            vm.productData[index].characteristic = vm.productDataEdit[index].characteristic;
            vm.productData[index].reason = vm.productDataEdit[index].reason;
            vm.productDataEdit[index].isEdit = false;
          }
        })
      } else {
        vm.productDataEdit[index].isEdit = false;
        vm.productDataEdit[index].characteristic = vm.productData[index].characteristic;
        vm.productDataEdit[index].reason = vm.productData[index].reason;
      }
    },

  }
}
</script>
<style lang="less" scoped>
</style>
